import React, { useContext } from 'react'

const StateContext = React.createContext({ state: {}, setState: () => {} })

export function withState(Component) {
  return function WrapperComponent(props) {
    return (
      <StateContext.Consumer>
        {(contexts) => <Component {...props} {...contexts} />}
      </StateContext.Consumer>
    )
  }
}

export const useStateContext = () => {
  const context = useContext(StateContext)

  return [context.state, context.setState]
}

export const StateProvider = StateContext.Provider
export const StateConsumer = StateContext.Consumer
